export default __webpack_public_path__ + "static/alamo_sea_lockup-bb7d622ada43ca1f072f61f7aa2bb2d8.png";